import { useDispatch, useSelector } from 'react-redux';
import { parseDate, getLocalTimeZone } from '@internationalized/date';
import { formatISO, format } from 'date-fns';
import { setSelectedDate } from '@store/global/slice';
import { selectSelectedDate } from '@store/global/selectors';
import { DatePicker } from 'components/date-picker/DatePicker';
import { ProgressBar } from 'components/date-progress-card/ProgressBar';
import { isIntRange } from '@utils/typescriptGuards';



interface DateProgressCardProps {
	deliveredPercent: number
}


export const DateProgressCard = (props: DateProgressCardProps) => {
	const { deliveredPercent } = props;

	const selectedDate = useSelector(selectSelectedDate);
	const dispatch = useDispatch();
	const updateSelectedDate = (value: string) => dispatch(setSelectedDate(value));

	return (
		<div className='component-date-progress-card'>
			
			<DatePicker
				label='Datum'
				value={selectedDate ? parseDate(format(selectedDate, 'yyyy-MM-dd')) : null}
				onChange={(date) => {
					if (date) {
						updateSelectedDate(formatISO(date.toDate(getLocalTimeZone())));
					}
				}}
			/>

			<ProgressBar label='Doručeno' progress={isIntRange(deliveredPercent, 0, 100) ? deliveredPercent : 0} />

		</div>
	)
}